import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { SwiperOptions } from 'swiper/types'
import { MenuItemType } from '@utils/types'
import { WContainer, Button, EditableTitle, EditableDescription } from '@components/atoms'
import styles from './CategoriaHubSection.module.sass'
import { CategoriaHubCard } from '@components/molecules'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const CategoriaHubSection = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WContainer>
        {editMode ? (
          <>{item.children}</>
        ) : (
          <div className={`${styles.list}`}>
            {item.children?.map((x) => (
              <CategoriaHubCard item={x} key={x.pk} className={styles.item} />
            ))}
          </div>
        )}
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default CategoriaHubSection
